import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Subject } from 'rxjs';
import { ThreeCanvasComponent } from 'src/app/core/ctc/canvas/canvas.component';
import { CanvasControllerService } from 'src/app/core/services/canvas-controller/canvas-controller.service';
import { CommonModule } from '@angular/common';
import { EmbedService } from 'src/app/core/layout/layouts/embed-layout/common/services/embed.service';

@Component({
  selector: 'app-project-embed',
  imports: [CommonModule, ThreeCanvasComponent],
  templateUrl: './project-embed.component.html',
  styleUrl: './project-embed.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProjectEmbedComponent implements OnInit, OnDestroy {
  private unsubscribeAll: Subject<any> = new Subject();

  constructor(
    private embedService: EmbedService,
    private canvasController: CanvasControllerService,
    private cd: ChangeDetectorRef,
  ) {}

  //--------------------------------------------------------------------------------------------------------
  // @ Life Circle
  //--------------------------------------------------------------------------------------------------------

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.unsubscribeAll.next(null);
    this.unsubscribeAll.complete();
    this.unsubscribeAll.unsubscribe();
  }

  //--------------------------------------------------------------------------------------------------------
  // @ Public Method
  //--------------------------------------------------------------------------------------------------------

  public created(canvas: ThreeCanvasComponent | undefined): void {
    if (!canvas) return;
    this.canvasController.initCavas(canvas);
    this.canvasController.canvas?.autoRatation(false);
    this.cd.markForCheck();
  }

  public isLoading(isLoading: boolean): void {
    this.embedService.isLoading = isLoading;
    this.cd.markForCheck();
  }

  public getMaterials(materials: Map<string, any>): void {
    this.canvasController.materials = materials;
    this.cd.markForCheck();
  }

  public deleteAttachStickerMeshName(e: { index: number; name: string }): void {}

  //--------------------------------------------------------------------------------------------------------
  // @ Private Method
  //--------------------------------------------------------------------------------------------------------
}
